<template>
  <div class="setSubProcess">
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px">数据对象类型</div>
      <el-radio v-model="tempNodeData.type" label="VAR">记录</el-radio>
      <el-radio v-model="tempNodeData.type" label="COUNT">数值</el-radio>
    </div>
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px">选择数据对象</div>
      <tree-select
        v-model="tempNodeData.var"
        :group-list="filteredWorkflowVarGroupControl"
        @input="change"
      ></tree-select>
    </div>
    <div class="contentItem">
      <div class="itemTitle" style="margin-bottom: 10px">自定义入参</div>
      <script-key-value-paris
        :list="inputs"
        :workflow-var-groups="workflowVarGroups"
        addItemText="+ key-value pairs"
      ></script-key-value-paris>
    </div>
    <div class="contentItem" v-if="tempNodeData.var && !oneFlag">
      <div class="itemTitle">多条执行方式</div>
      <el-radio-group v-model="tempNodeData.sequential">
        <el-radio :label="true">逐条执行</el-radio>
        <el-radio :label="false">并行</el-radio>
      </el-radio-group>
    </div>
    <div class="contentItem" v-if="tempNodeData.var">
      <div class="itemTitle" style="margin-bottom: 10px">执行子流程</div>
      <div v-if="!subProcessDisable" style="display: flex; align-items: center;">
        <NormalSelect
          class="subprocess"
          size="normal"
          :selectList="subProcess"
          :selectedItem.sync="tempNodeData.subProcessId"
        ></NormalSelect>
        <el-button type="primary" @click="createSubProcess">新建</el-button>
      </div>
      <div v-else>
        <div class="disabled">
          <span style="padding-right: 10px">{{ info.name }}</span>
          <el-tag v-if="!info.enable" type="info" effect="dark" size="mini">
            禁用
          </el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">启用</el-tag>
        </div>
      </div>
      <!--工作流目前不支持这个选项,先藏起来-->
      <!--<div>-->
      <!--  <el-checkbox v-model="tempNodeData.async">子流程执行完毕后，再开始下一个节点</el-checkbox>-->
      <!--</div>-->
    </div>
    <div class="contentItem">
      <el-checkbox :value="!_.isEmpty(tempNodeData.output)" @input="changeOutput">
        是否设置出参
      </el-checkbox>
    </div>
    <div class="contentItem" v-if="!_.isEmpty(tempNodeData.output)">
      <div class="itemTitle">出参列表</div>
      <output-params
        ref="outputParams"
        from="subProcess"
        :output-params="tempNodeData.output"
      ></output-params>
    </div>
  </div>
</template>

<script>
import { deepClone, randomString } from "@/utils/common"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import { getAllWorkflow, createWorkflow, getWorkflow } from "@/api/workflow/workflow"
import { bfs } from "@/utils/algorithm"
import { filterTreeVarGroup, transOldExpr } from "@/utils/workFlow"
import ScriptKeyValueParis from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/ScriptKeyValuePairs"
import mixin from "../components/setHttpRequest/mixin"
import OutputParams from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/OutputParams"

export default {
  name: "setSubProcess",
  components: { OutputParams, ScriptKeyValueParis, NormalSelect, TreeSelect },
  props: {
    nodeInfo: Object,
    workflowVarGroup: Array,
    extra: Object,
    appId: String,
    workflowVarGroups: Array,
    workFlowVarMap: Object
  },
  mixins: [mixin],
  data() {
    return {
      tempNodeData: {
        type: "VAR"
      },
      workflowList: [],
      inputs: [],
      subProcessControl: {},
      info: {},
      subProcessDisable: false
    }
  },
  watch: {
    subProcessName: {
      immediate: true,
      handler() {
        if (this.tempNodeData?.subProcessId && this.subProcessName) {
          this.$set(this.extra, "description", {
            subProcessId: this.tempNodeData.subProcessId,
            subProcessName: this.subProcessName
          })
        }
      }
    }
  },
  computed: {
    filteredWorkflowVarGroupControl() {
      if (this.tempNodeData.type == "COUNT") {
        return filterTreeVarGroup({
          varGroup: this.workflowVarGroup,
          filterFunc: option => {
            // 当数据对象类型为数值类型时，返回type为number的option
            if (option.control._type == "number") return true
            return false
          }
        })
      }
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: option => {
          if (this._.isEmpty(this.subProcessControl)) return true
          if (this.subProcessControl._type !== option.control._type) return false
          if (this.subProcessControl._type !== "ref") return true
          return this.subProcessControl.refSheetId === option.control.refSheetId
        }
      })
    },
    workFlowInfo() {
      let map = {}
      bfs({
        arr: this.filteredWorkflowVarGroupControl,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(
            option => (map[option.value] = { control: option.control, isArray: option.isArray })
          )
        }
      })
      return map
    },
    subProcess() {
      return this.workflowList
        .filter(
          workFlow =>
            workFlow.trigger?.type === "START_TYPE_SUB" &&
            workFlow.trigger?.control._type ===
              this.workFlowInfo?.[this.tempNodeData?.var]?.control?._type &&
            (workFlow.trigger?.control._type === "ref"
              ? workFlow.trigger?.control.refSheetId ===
                this.workFlowInfo?.[this.tempNodeData?.var]?.control?.refSheetId
              : true)
        )
        .map(workFlow => ({ label: workFlow.name, value: workFlow.id }))
    },
    oneFlag() {
      return !this.workFlowInfo?.[this.tempNodeData.var]?.control?.array
    },
    subProcessName() {
      let subProcess = this.workflowList.find(
        workFlow => workFlow.id === this.tempNodeData?.subProcessId
      )
      return subProcess === undefined ? "" : subProcess.name
    }
  },
  created() {
    this.tempNodeData = deepClone(this.nodeInfo).data
    this.initialData()
    this.getWorkflows()
    this.getWorkflowInfo()
  },
  methods: {
    initialData() {
      this.tempNodeData.var = transOldExpr(this.tempNodeData.var)
      this.subProcessDisable = Boolean(this.tempNodeData.subProcessId)
      // input
      this.tempNodeData.extraInput?.forEach(input => {
        this.inputs.push({
          key: input.name,
          value: {
            inFlow: false,
            label: transOldExpr(input.expresion),
            value: transOldExpr(input.expresion)
          }
        })
      })
      // output
      if (!this._.keys(this.tempNodeData).includes("output")) {
        this.$set(this.tempNodeData, "output", null)
      }
    },
    getWorkflowInfo() {
      if (this.tempNodeData.subProcessId) {
        getWorkflow(this.tempNodeData.subProcessId).then(res => {
          this.subProcessControl = res.trigger.control
          this.info = { name: res.name, enable: res.enable }
        })
      }
    },
    getWorkflows() {
      return getAllWorkflow(this.appId).then(workflowList => {
        this.workflowList = workflowList
      })
    },
    createSubProcess() {
      let control = this.workFlowInfo[this.tempNodeData?.var]?.control
      if (!control) {
        this.$message.error("数据对象有误,请刷新后重试")
        return
      }
      control.oneFlag = true // 子流程的触发控件默认单选
      if (!this.verifyPairs(this.inputs, "submit", " 传入变量 ")) return
      let extraInput = this.inputs.map(item => {
        return Object.assign({}, this.workFlowVarMap[item.value.value], { name: item.key })
      })
      createWorkflow(
        {
          name: "未命名工作流",
          trigger: { type: "START_TYPE_SUB", control: control, extraInput }
        },
        this.appId
      ).then(res => {
        this.getWorkflows().then(() => {
          this.tempNodeData.subProcessId = res.data.data.id
        })
      })
    },
    change() {
      this.tempNodeData.single = !this.workFlowInfo?.[this.tempNodeData.var]?.isArray
      this.subProcessDisable = false
      this.tempNodeData.subProcessId = ""
    },
    changeOutput(val) {
      this.tempNodeData.output = val
        ? {
            paramId: randomString(10),
            _type: "ref",
            array: false,
            name: ""
          }
        : null
    }
  }
}
</script>

<style lang="scss">
.setSubProcess {
  .contentItem {
    .el-radio-group {
      padding-top: 10px;
    }
    .el-checkbox {
      padding-top: 10px;
      .el-checkbox__label {
        font-size: 13px;
      }
    }
    .disabled {
      background: #f5f5f5;
      padding: 10px;
      border-radius: 4px;
    }
    .subprocess {
      margin-right: 3px;
    }
  }
}
</style>
